__turbopack_context__.v({
  "disabled": "text-label-module-scss-module__sx1WBG__disabled",
  "placeholder": "text-label-module-scss-module__sx1WBG__placeholder",
  "text": "text-label-module-scss-module__sx1WBG__text",
});
